import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'font-inter font-medium rounded-md inline-flex items-center justify-center transition-colors';
  const variantStyles = {
    primary: 'bg-primary-royal-blue hover:bg-primary-deep-blue text-white',
    secondary: 'border-2 border-primary-royal-blue text-primary-royal-blue hover:bg-primary-royal-blue hover:text-white',
    tertiary: 'text-primary-royal-blue hover:underline'
  };
  const sizeStyles = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-6 py-3'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <Link to={href} className={styles} data-id="element-245">
        {children}
      </Link>;
  }
  return <button type={type} onClick={onClick} className={styles} data-id="element-246">
      {children}
    </button>;
}